module.exports = __webpack_public_path__ + "static/img/mk2.7fff6c04.svg";